import { defineComponent as _defineComponent } from 'vue'
import { ProfileStoreKey } from '@/models/Profile';
import useProfileState from '@/state/profile/profileState';
import ProfileSection from '@/views/profile/components/ProfileSection.vue';
import ProfileBasicEditor from '@/views/profile/components/editors/ProfileBasicEditor.vue';
import ProfileBasicView from '@/views/profile/components/views/ProfileBasicView.vue';
import ProfileInvitedBy from '@/views/profile/components/views/ProfileInvitedBy.vue';
import BCXContentArea from '@/components/molecules/BCXContentArea.vue';
import BCXBreadcrumbs from '@/components/molecules/BCXBreadcrumbs.vue';
import ProfileAboutusView from '@/views/profile/components/views/ProfileAboutusView.vue';
import ProfileMembersView from '@/views/profile/components/views/ProfileMembersView.vue';
import ProfilePublicProjectsView from '@/views/profile/components/views/ProfilePublicProjectsView.vue';
import ProfileAboutusEditor from '@/views/profile/components/editors/ProfileAboutusEditor.vue';
import ProfileCreateProjectLink from '@/views/profile/components/views/ProfileCreateProjectLink.vue';
import SettingsIcon from '@/components/svg/settings.svg?inline';
import useResponsiveness from '@/mixins/useResponsiveness';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileCompany',
  setup(__props) {

const {
  isSelf, isEditSectionOpen, isSectionFilled,
} = useProfileState(ProfileStoreKey.PROFILE);

const { isMobileWidth } = useResponsiveness();

return { __sfc: true,isSelf, isEditSectionOpen, isSectionFilled, isMobileWidth, ProfileSection, ProfileBasicEditor, ProfileBasicView, ProfileInvitedBy, BCXContentArea, BCXBreadcrumbs, ProfileAboutusView, ProfileMembersView, ProfilePublicProjectsView, ProfileAboutusEditor, ProfileCreateProjectLink, SettingsIcon }
}

})